import Plyr from 'plyr/dist/plyr.js';
import { Base } from '@studiometa/js-toolkit';

/**
 * Video
 */
export default class Video extends Base {
  static config = {
    name: 'Video',
    refs: ['videoText'],
  };

  player = null;

  controls = null;

  /**
   * on mounted init player
   */
  mounted() {
    this.player = new Plyr('#player');
    this.player.on('playing', this.playing.bind(this));
    this.player.on('pause', this.pausing.bind(this));
    this.controls = document.querySelector('.plyr__controls');
  }

  /**
   * If video is playing
   */
  playing() {
    if (this.$refs.videoText) {
      this.$refs.videoText.classList.add('cover--hidden');
    }
    this.controls.style.display = 'flex';
  }

  /**
   * on pause
   */
  pausing() {
    if (this.$refs.videoText) {
      this.$refs.videoText.classList.remove('cover--hidden');
    }

    this.controls.style.display = 'none';
  }
}
